import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import * as Actions from '../actions/analysisSimulatorAction';
import {
  AnalysisSimulatorState,
  initResponseAnalysisSimulatorData
} from '../models/analysisSimulatorModel';

export const analysisSimulatorReducer = createReducer<
  AnalysisSimulatorState,
  Actions.AnalysisSimulatorAction
>(initResponseAnalysisSimulatorData)
  .handleAction(Actions.dispatchSearch, (state, action) =>
    produce(state, draft => {
      const { searchParams } = action.payload;
      draft.searchParams = searchParams;
    })
  )
  // .handleAction(Actions.list.request, (state, action) =>
  //   produce(state, draft => {
  //     const { searchParams, page } = action.payload;

  //     draft.searchParams = searchParams;
  //     draft.page = page;
  //   })
  // )
  .handleAction(Actions.list.success, (state, action) =>
    produce(state, draft => {
      const { data, count, total, page } = action.payload;
      if (!state.list) {
        draft.list = data;
      } else {
        if (page === 1) {
          draft.list = data;
          draft.page = page;
          return;
        }
        draft.list = state.list?.concat(data);
      }

      draft.page = page;
      draft.count = count;
      draft.total = total;
    })
  )
  .handleAction(Actions.detail.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.detail = data;
    })
  )
  .handleAction(Actions.stcs.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      draft.stcsList = data;
      draft.stcsCount = count;
    })
  )

  .handleAction(Actions.log.success, (state, action) =>
    produce(state, draft => {
      const { log } = action.payload;
      const data = log.sort((p: any, n: any): any => {
        const a = p.srvrRcvDt.replace(/[^0-9\.]+/g, '');
        const b = n.srvrRcvDt.replace(/[^0-9\.]+/g, '');
        return a - b;
      });
      draft.log = log;
    })
  );
